import {GetHealthCard} from 'domain/usecases';
import {RemoteGetHealthCard} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {HealthCardEndPoint} from 'main/factories/usecases/endpoints';

export const makeGetHealthCard = (): GetHealthCard =>
	new RemoteGetHealthCard(
		makeBFFApiUrl(HealthCardEndPoint.healthCard),
		makeAuthorizeHttpClientDecorator(),
	);
